const COMPANY_ID_KEY = "companyId";
const DEFAULT_COMPANY_ID = "1";

export const getCompanyId = (): string =>
  localStorage.getItem(COMPANY_ID_KEY) || DEFAULT_COMPANY_ID;